/*
 * This delays the loading of videos on the website
 * by adding the "src" attribute to the video tag on window load only
 * */

export default function delayVideoLoad(els) {
    return (function () {
        const init = () => {
            const videosWithDelay = Array.prototype.slice.call(els);

            videosWithDelay.forEach(video => {
                Array.prototype.slice
                    .call(video.children)
                    .filter(child => child.tagName === 'SOURCE')
                    .forEach(
                        videoSource => (videoSource.src = videoSource.dataset.videoSrc)
                    );

                video.load();
            });
        };

        return {
            init,
        };
    })().init();
}
